import { FC } from 'react'
import { Stack, Switch, Typography } from '@dtx-company/design-system/src'

export const LinkStyleToggle: FC<{
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}> = ({ checked, onChange, disabled }) => {
  return (
    <Stack justifyContent="space-between" alignItems="center" direction="row">
      <Stack direction="column">
        <Typography
          variant="labelLarge"
          id="advanced-customization"
          color={disabled ? 'secondary.disabled' : 'primary.black'}
        >
          Advanced customization
        </Typography>
        <Typography
          variant="labelMedium"
          color={disabled ? 'secondary.dark' : 'primary.light'}
          id="customization-helper-text"
        >
          Personalize your link color and font style
        </Typography>
      </Stack>
      <Stack>
        <Switch
          hiddenLabel
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          label="advanced-customization"
          inputProps={{ 'aria-describedby': 'customization-helper-text' }}
          disabled={disabled}
        />
      </Stack>
    </Stack>
  )
}
